/*eslint-disable no-undef*/
import React from 'react';
import "./assets/vendors/style";
import './less/index.less';

import {
    HashRouter as Router,
  Route
} from "react-router-dom";
import {Provider} from 'react-redux'

import { store } from './appRedux/store'
import AppLayout from './components/layout';

class App extends React.Component {
    render() {
        return (
            <Provider store={store}>
                <Router>
                    <Route path="" component={AppLayout}/>
                </Router>
            </Provider>
        );
    }
}

export default App;